import { LoginComponent } from '@official/pages/login/login.component';
import { NotFoundComponent } from '@official/pages/not-found/not-found.component';
import { Routes } from '@angular/router';

import { LoginGuard } from '@official/guards/login.guard';
import { LogoutGuard } from '@official/guards/logout.guard';

export enum RouteNamesEnum {
  Login = 'inicio-sesion',
  MapViewer = 'visor-mapa',
  UserManagement = 'manage-users',
  ManageCameras = 'manage-cameras',
  Reports = 'reports',
  Links = 'links',
  Simac = 'simac',
  observatory = 'observatory',
  RolesManagement = 'manage-roles',
  ManageAudit = 'manage-audit',
  ManageAlerts = 'manage-alert',
  ManageSensor = 'manage-sensors',
  ManagePMV = 'manage-pmv',
  BlackWhiteLists = 'black-white-lists',
}

export const OFFICIALRoutes: Routes = [
  {
    path: RouteNamesEnum.MapViewer,
    loadChildren: () =>
      import('../pages/map-viewer/map-viewer.module').then(
        (m) => m.MapViewerModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: RouteNamesEnum.Login,
    component: LoginComponent,
    canActivate: [LogoutGuard],
  },
  {
    path: RouteNamesEnum.ManageAlerts,
    loadChildren: () =>
      import('../pages/alert-management/alert-management.module').then(
        (m) => m.AlertManagementModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: RouteNamesEnum.ManageSensor,
    loadChildren: () =>
      import('../pages/sensor-management/sensor-management.module').then(
        (m) => m.SensorManagementModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: RouteNamesEnum.UserManagement,
    loadChildren: () =>
      import('../pages/user-management/user-management.module').then(
        (m) => m.UserManagmentModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: RouteNamesEnum.RolesManagement,
    loadChildren: () =>
      import('../pages/roles-management/roles-management.module').then(
        (m) => m.RolesManagementModule
      ),
    canActivate: [LoginGuard]
  },
  {
    path: RouteNamesEnum.ManageAudit,
    data: { breadcrumb: 'Auditoria' },
    loadChildren: () =>
      import('../pages/manage-audit/manage-audit.module').then(
        (m) => m.ManageAuditModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: RouteNamesEnum.BlackWhiteLists,
    loadChildren: () =>
      import('../pages/black-white-lists/black-white-lists.module').then(
        (m) => m.BlackWhiteListsModule
      ),
    canActivate: [LoginGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: RouteNamesEnum.Login,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
